// account
export const SET_ACCOUNT = 'setAccount';
export const SET_SESSION_TOKEN = 'setToken';

// users
export const SET_USER = 'setUser';
export const SET_USER_STATS = 'setUserStats';
export const SET_USERS = 'setUsers';

// organization
export const SET_ORGANIZATION = 'setOrganization';
export const SET_ORGANIZATIONS = 'setOrganizations';
export const SET_ORGANIZATION_STATS = 'setOrganizationStats';

// screen
export const SET_SCREEN = 'setScreen';
export const SET_SCREENS = 'setScreens';

// ticket
export const SET_TICKET = 'setTicket';
export const SET_TICKETS = 'setTickets';
export const SET_TICKET_UNREAD = 'setTicketUnread';
export const SET_TICKET_IN_LIST = 'setTicketInList';

// ticket_comment
export const SET_TICKET_COMMENT = 'setTicketComment';
export const SET_TICKET_COMMENTS = 'setTicketComments';
export const SET_TICKET_IN_THREAD = 'setTicketInThread';

// sidenav
export const SET_SIDENAV = 'setSidenav';

// router_loader
export const SET_ROUTER_LOADER = 'setRouterLoader';

// error
export const SET_ERRORMSG = 'setErrorMsg';

// activity log
export const SET_ACTIVITY_LOGS = 'setActivityLogs';

// dashboard
export const SET_DASHBOARD = 'setDashboard';

// organization settings
export const MERGE_ORGANIZATION = 'mergeOrganization';

// support session
export const SET_SUPPORT_SESSION = 'setSupportSession';
export const SET_SUPPORT_SESSION_LAUNCHER = 'setSupportSessionLauncher';
export const SET_SUPPORT_SESSION_ISLOADING = 'setSupportSessionIsLoading';
export const SET_SUPPORT_SESSION_VERIFIED = 'setSupportSessionVerified';
export const SET_SUPPORT_SESSION_PATH = 'setSupportSessionPath';
